import i18next from 'i18next';

i18next.addResources('es', 'instinfoHome', {
  whoWeAreTitle: 'Quiénes somos',
  whoWeAreText: 'La unión renovada de tres bancos de desarrollo comprometidos con la integración regional.',
  whatWeDoTitle: 'Qué hacemos',
  whatWeDoText: `Brindamos apoyo técnico y financiero a proyectos de infraestructura de integración. Generamos conocimiento y tecnología aplicada a la planificación e implementación de esos proyectos.`,
  whyWeDoItTitle: 'Por qué lo hacemos',
  whyWeDoItText: `Para consolidar el desarrollo y la integración de América Latina y el Caribe de forma sostenible y respetuosa con el medio ambiente.`,
  ourGoalTitle: 'Nuestro objetivo',
  ourGoalText: `Ser un espacio de trabajo para el desarrollo de infraestructura de integración de calidad e innovadora en un marco de transparencia y colaboración.`,
});

i18next.addResources('en', 'instinfoHome', {
  whoWeAreTitle: 'Who We Are',
  whoWeAreText: 'The renewed union of three development banks committed to regional integration.',
  whatWeDoTitle: 'What We Do',
  whatWeDoText: `We provide technical and financial support to integration infrastructure projects. We generate knowledge and technology applied to the planning and implementation of these projects.`,
  whyWeDoItTitle: 'Why We Do It',
  whyWeDoItText: `To consolidate the development and integration of Latin America and the Caribbean in a sustainable and environmentally respectful manner.`,
  ourGoalTitle: 'Our Goal',
  ourGoalText: `To be a workspace for the development of quality and innovative integration infrastructure in a framework of transparency and collaboration.`,
});

i18next.addResources('pt', 'instinfoHome', {
  whoWeAreTitle: 'Quem Somos',
  whoWeAreText: 'A união renovada de três bancos de desenvolvimento comprometidos com a integração regional.',
  whatWeDoTitle: 'O Que Fazemos',
  whatWeDoText: `Oferecemos apoio técnico e financeiro a projetos de infraestrutura de integração. Geramos conhecimento e tecnologia aplicada ao planejamento e implementação desses projetos.`,
  whyWeDoItTitle: 'Por Que Fazemos',
  whyWeDoItText: `Para consolidar o desenvolvimento e a integração da América Latina e do Caribe de forma sustentável e respeitosa com o meio ambiente.`,
  ourGoalTitle: 'Nosso Objetivo',
  ourGoalText: `Ser um espaço de trabalho para o desenvolvimento de infraestrutura de integração de qualidade e inovadora em um marco de transparência e colaboração.`,
});
